// Cola de certificación del catálogo (§11): lo que publica un autor fuera del equipo no se puede instalar hasta
// que alguien de Glubi mire sus reglas y decida. Es lo que sostiene el nivel «certificada» de la Fase 3.
import { PageHead } from '@glubi/ds';
import { ColaDeCertificacion } from '../componentes/ColaDeCertificacion';

export function Certificacion() {
  return (
    <div className="page">
      <PageHead
        title="Certificación"
        subtitle="Versiones esperando revisión. Certificar deja la solución instalable para cualquier negocio; publicarla como comunidad la deja a la vista con su advertencia, sin poder instalarse."
      />
      <ColaDeCertificacion />
    </div>
  );
}
